import { take } from 'rxjs/operators';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empresa } from './../../_models/empresa';
import { EmpresaService } from './../../_services/empresa.service';
import { Component, OnInit, } from '@angular/core';
import { User } from '../../_models/user';
import { UserService, AuthenticationService } from '../../_services/index';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { SolrService } from '../../solr/solr.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AdminMenuItem, ControlSidebarService } from '../../_services/control-sidebar.service';

@Component({
  /* tslint:disable */
  selector: '.userBox',
  /* tslint:enable */
  styleUrls: ['./user-box.component.scss'],
  templateUrl: './user-box.component.html',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule]
})
export class UserBoxComponent implements OnInit {

  // default user, only an example, please use the userService to modify
  public currentUser: User = new User({
    avatarUrl: '',
    email: 'weber.antoine@outlook.com',
    firstname: 'WEBER',
    lastname: 'Antoine'
  });
  showChangeCompany = true;
  showChangeRole = false;
  userCompany: any;
  fields = [];
  objModalLoadFilter: any = {};
  usedModalLoadFilter = false;
  memberSince: any;
  selectedCompany: any;
  noCompanySelected: any;
  chooseCompany: any;
  avatarFailed = false;
  adminItems: AdminMenuItem[] = [];

  get hasAvatar(): boolean {
    const url = this.currentUser?.avatarUrl;
    // o backend pode devolver o avatar genérico; nesse caso vale a inicial do nome
    const isDefaultAvatar = !!url && /(^|\/)assets\/img\/avatar\.png$/.test(url);
    return !!url && !isDefaultAvatar && !this.avatarFailed;
  }

  // Sem foto: primeira letra do nome (padrão Taxfy)
  get initial(): string {
    const name = (this.currentUser?.firstname || this.currentUser?.email || '?').trim();
    return name.charAt(0).toUpperCase();
  }

  get companyName(): string {
    const emp = this.userCompany?.selectedEmpresa;
    return emp ? (emp.nomeFantasia || emp.razaoSocial || '') : '';
  }

  get companyId(): string {
    return this.userCompany?.selectedEmpresa?._id || '';
  }

  get roleName(): string {
    if (this.userCompany?.selectedRole && !this.userCompany?.masterAdmin) {
      return this.userCompany.selectedRole.nome || '';
    }
    return this.userCompany?.isAdmin ? 'Administrador' : '';
  }

  // stopPropagation: sem isso o clique fecharia o dropdown do Bootstrap
  copyCompanyId(event: Event) {
    event.stopPropagation();
    navigator.clipboard?.writeText(this.companyId).then(
      () => this.notifierService.success('ID copiado'),
      () => this.notifierService.error('Não foi possível copiar o ID')
    );
  }

  get hello(): string {
    return this.translate.instant('SHARED.hello') === 'SHARED.hello' ? 'Olá' : this.translate.instant('SHARED.hello');
  }
  signOut: any;

  constructor(private userServ: UserService,
    private authService: AuthenticationService,
    private router: Router,
    private notifierService: ToastrService,
    private empresaService: EmpresaService,
    private solrService: SolrService,
    private userService: UserService,
    private controlSidebarService: ControlSidebarService,
    private modalService: BsModalService,
    public translate: TranslateService,
  ) {
    let storelang = localStorage.getItem("lang") || 'pt';
    this.translate.reloadLang(storelang).subscribe((dataTranslate: any) =>{
        this.memberSince = dataTranslate.SHARED.memberSince;
        this.selectedCompany = dataTranslate.SHARED.selectedCompany;
        this.noCompanySelected = dataTranslate.SHARED.noCompanySelected;
        this.chooseCompany = dataTranslate.PAGES.chooseCompany || 'Escolha Empresa';
        this.signOut = dataTranslate.PAGES.signOut;
    })
    
  }

  public ngOnInit() {
    // TODO
    // if (localStorage.getItem('currentUser') || null || null) {
    //   this.userCompany = JSON.parse(localStorage.getItem('currentUser'));
    // }
    this.currentUser = this.authService.currentUserValue;
    this.userCompany = this.currentUser;
    this.adminItems = this.controlSidebarService.getMenuItems(this.currentUser);
    if(this.currentUser?.role?.length > 1) {
      this.showChangeRole = true;
    }
    // tslint:disable-next-line: max-line-length
    if(this.currentUser?.selectedRole) {
      if(this.currentUser.selectedRole?.empresas?.length > 1) {
        this.showChangeCompany = true;
      } else {
        this.showChangeCompany = false;
      }
    } else {
      if ('empresas' in this.currentUser && (this.currentUser?.empresas?.length === 1) && !((this.currentUser?.empresas?.[0]?.empresas?.length > 0))) {
        this.showChangeCompany = false;
      }
    }

  }
  profile() {

  }
  changeGroup() {
    const options: { [key: string]: any } = {};
    const dictRole: { [key: string]: any } = {};
    this.currentUser?.role?.forEach((data: any) => {
      options[data._id] = data.nome;
      dictRole[data._id] = data;
    });
    Swal.fire({
      title: this.translate.instant('SHARED.acessProfileSelection'),
      // tslint:disable-next-line: max-line-length
      html: this.translate.instant('SHARED.selectProfile'),
      input: 'select',
      inputOptions: options,
      inputPlaceholder: this.translate.instant('select'),
      showCancelButton: true,
      inputValidator: (value: any) => {
        return new Promise((resolve) => {
          // console.log('VALUE ROLE:', value);
          if(value) {
            this.userCompany = this.currentUser;
            this.userCompany.selectedGroup = dictRole[value];
            this.authService.setCurrentUser(this.userCompany);
            this.userService.updateMongo(this.userCompany).subscribe((data: any) => {
              // localStorage.setItem('currentUser', JSON.stringify(this.userCompany));
              this.solrService.applyEmpresaFilter([], true);
              resolve(undefined);
            });
          } else {
            Swal.fire({
              title: this.translate.instant('SHARED.acessProfileNotSelected'),
              icon: 'warning',
              showCancelButton: false,
              cancelButtonText: 'Fechar',
            });
          }
        });
      }
    });
  }

  change() {
    this.currentUser = this.authService.currentUserValue;
    const myempresas: any[] = [];
    if(this.currentUser?.selectedRole) {
      this.currentUser.selectedRole?.empresas?.forEach((data: any) => {
        if(data?._id !== this.currentUser?.selectedEmpresa?._id) {
          myempresas.push(data);
        }
      });
      this.userService.change(myempresas, 'userBox');
    } else {
      this.userService.change(this.currentUser?.empresas || [], 'userBox');
    }
    this.empresaService.getEmpresaSelecionada().pipe(take(1)).subscribe((emp: any) => {
      this.userCompany.selectedEmpresa = emp;
    });
  }

  changeCompany() {
    // debugger;
    const options: { [key: string]: any } = {};
    const filialOptions: { [key: string]: any } = {};
    const user = this.authService.currentUserValue;
    // tslint:disable-next-line: max-line-length
    this.objModalLoadFilter = JSON.parse((sessionStorage.getItem('modalFilterUsed') || '{}')) ? JSON.parse(sessionStorage.getItem('modalFilterUsed') || '{}') : {};
    if(this.authService.currentUserValue?.selectedEmpresa?._id && this.authService.currentUserValue.selectedEmpresa._id in this.objModalLoadFilter) {
      this.usedModalLoadFilter = this.objModalLoadFilter[this.authService.currentUserValue.selectedEmpresa._id]?.isUsed;
    } else {
      this.usedModalLoadFilter = false;
    }
    const obj: { [key: string]: any } = this.objModalLoadFilter ? this.objModalLoadFilter : {};
    if (this.currentUser?.selectedEmpresa?._id) {
      obj[this.currentUser.selectedEmpresa._id] = { isUsed: false };
    }
    sessionStorage.setItem('modalFilterUsed', JSON.stringify(obj));


    user?.empresas?.sort(function (a: any, b: any) {
      if(a.razaoSocial > b.razaoSocial) {
        return 1;
      }
      if(a.razaoSocial < b.razaoSocial) {
        return -1;
      }
      // a must be equal to b
      return 0;
    }).forEach((data: any) => {
      options[data._id] = data.razaoSocial;
    });

    let plus1name = '';
    let swalResults = [];

    // First step: Company selection
    Swal.fire({
      title: this.translate.instant('SHARED.selectTheBusinessEnvironment'),
      text: this.translate.instant('SHARED.pleaseBeginBySelectingCompany'),
      input: 'select',
      inputPlaceholder: this.translate.instant('SHARED.pleaseSelect'),
      inputOptions: options,
      confirmButtonText: 'OK &rarr;',
      showCancelButton: false,
      allowOutsideClick: false,
      inputValidator: (value: any) => {
        if (!value) {
          return this.translate.instant('SHARED.companyNotSelected');
        }
        return null;
      }
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        this.empresaService.getById(result.value).subscribe((emp: Empresa) => {
          this.solrService.query = '&fq=client_id%3A' + emp._id;
          this.solrService.queryFilter = '';
          this.userCompany = user;
          this.userCompany.selectedEmpresa = emp;
          user.selectedEmpresa = emp;
          
          if(emp.empresas?.length > 0 && emp.multiempresa) {
            emp.empresas.sort(function (a: any, b: any) {
              if(a.razaoSocial > b.razaoSocial) {
                return 1;
              }
              if(a.razaoSocial < b.razaoSocial) {
                return -1;
              }
              return 0;
            }).forEach((data: any) => {
              (filialOptions as { [key: string]: any })[data._id] = data.razaoSocial;
            });
            this.empresaService.setEmpresaSelecionada(emp);
            
            // Second step: Branch selection
            Swal.fire({
              title: this.translate.instant('SHARED.client/BrancSelection'),
              text: this.translate.instant('SHARED.ifYouWantToEnterTheSpecific'),
              input: 'select',
              inputPlaceholder: this.translate.instant('SHARED.pleaseSelect'),
              inputOptions: filialOptions,
              confirmButtonText: 'OK',
              showCancelButton: false,
              allowOutsideClick: false
            }).then((branchResult) => {
              if (branchResult.isConfirmed) {
                if(branchResult.value === '' || !branchResult.value) {
                  this.authService.setCurrentUser(user);
                  this.solrService.applyEmpresaFilter([this.userCompany.selectedEmpresa], true);
                } else {
                  this.empresaService.getById(branchResult.value).subscribe((branchEmp: Empresa) => {
                    this.solrService.query = '&fq=client_id%3A' + branchEmp._id;
                    this.solrService.queryFilter = '';
                    user.selectedEmpresa = branchEmp;
                    this.userCompany.selectedEmpresa = branchEmp;
                    this.authService.setCurrentUser(user);
                    this.solrService.applyEmpresaFilter([branchEmp], true);
                  });
                }
              }
            });
          } else {
            user.selectedEmpresa = emp;
            this.userCompany.selectedEmpresa = emp;
            this.authService.setCurrentUser(user);
            this.solrService.applyEmpresaFilter([emp], true);
          }
        });
      }
    });
  }
  _changeCompany() {
    const options: { [key: string]: any } = {};
    this.currentUser?.selectedEmpresa?._id;
    this.objModalLoadFilter = JSON.parse(sessionStorage.getItem('modalFilterUsed') || '{}') ? JSON.parse(sessionStorage.getItem('modalFilterUsed') || '{}') : {};
    if(this.authService.currentUserValue?.selectedEmpresa?._id && this.authService.currentUserValue.selectedEmpresa._id in this.objModalLoadFilter) {
      this.usedModalLoadFilter = this.objModalLoadFilter[this.authService.currentUserValue.selectedEmpresa._id]?.isUsed;
    } else {
      this.usedModalLoadFilter = false;
    }
    const obj: { [key: string]: any } = this.objModalLoadFilter ? this.objModalLoadFilter : {};
    if (this.currentUser?.selectedEmpresa?._id) {
      obj[this.currentUser.selectedEmpresa._id] = { isUsed: false };
    }
    sessionStorage.setItem('modalFilterUsed', JSON.stringify(obj));
    function compareStrings(a: any, b: any) {
      // Assuming you want case-insensitive comparison
      // a = a.toLowerCase();
      // b = b.toLowerCase();

      return (a < b) ? -1 : (a > b) ? 1 : 0;
    }
    this.authService.currentUserValue?.empresas?.sort((a: Empresa, b: Empresa) => compareStrings(a.razaoSocial, b.razaoSocial))?.forEach((data: any) => {
      options[data._id] = data.razaoSocial;
    });
    Swal.fire({
      title: this.translate.instant('SHARED.companySelection'),
      // tslint:disable-next-line: max-line-length
      html: this.translate.instant('SHARED.selectComnpnayData'),
      input: 'select',
      inputOptions: options,
      inputPlaceholder: this.translate.instant('select'),
      showCancelButton: true,
      inputValidator: (value: any) => {
        return new Promise((resolve) => {
          // console.log('VALUE EMPRESA:', value);
          if(value) {
            // this.solrService.clear();
            this.empresaService.getById(value).subscribe((emp: Empresa) => {
              this.solrService.query = '&fq=client_id%3A' + emp._id;
              this.solrService.queryFilter = '';
              this.empresaService.setEmpresaSelecionada(emp);
              this.userCompany = this.currentUser;
              this.userCompany.selectedEmpresa = emp;
              this.authService.setCurrentUser(this.userCompany);
              // localStorage.setItem('currentUser', JSON.stringify(this.userCompany));
              this.solrService.applyEmpresaFilter([emp], true);
              resolve(undefined);

            });
          } else {
            Swal.fire({
              title: this.translate.instant('SHARED.companyNotSelected'),
              icon: 'warning',
              showCancelButton: false,
              cancelButtonText: 'Fechar',
            });
          }
        });
      }
    });
  }

  public logout = (): void => {
    this.authService.logout().subscribe((data: any) => {
        // console.log(`logout: ${data}`);
      },
      error => {
        this.notifierService.error(error.message || error.statusText);
      });

  }
}
